export default defineNuxtPlugin(() => {
  if (typeof window === 'undefined') return

  import('airbridge-web-sdk-loader').then(() => {
    useAirbridge().initAirbridge()
  })
})
